import React, { useEffect, useState } from 'react';
import { Grid, Box, Modal, Typography, Button, LinearProgress } from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import {deleteDevice, deleteTruck} from 'apis/device';

interface DeleteTruckProps {
  open: boolean;
  handleClose: Function | any;
  truck: { truckName: string, truckId: number } | null;
  getTruck: Function;
}


const DeleteTruckModal: React.FC<DeleteTruckProps> = ({ open, handleClose, truck, getTruck }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");

  console.log(truck);

  const handleDeleteTruck = async () => {
    console.log(truck);
    setErr("");
    setIsLoading(true);
    if (truck !== null) {
      let data = await deleteTruck(truck.truckId);
      console.log(data);
      if (data?.response?.data?.errorMessage) {
        setIsLoading(false);
        setErr(data.response.data.errorMessage);
        return
      }
      if (data) {
        setIsLoading(false);
        handleClose(false);
        getTruck();
      }
    } else {
      setIsLoading(false);
      handleClose(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Box sx={{...styles.container, height: "max-content"}}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {err !== "" && <Typography sx={{color: "red", fontSize: ".7rem"}}>{err}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>Delete Truck</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>
          <Grid item xs={12}>
            <Typography>Are you sure you want to delete Truck {truck !== null && truck.truckName}?</Typography>
          </Grid>

          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>No</Button>
            <Button sx={styles.addButton} onClick={() => handleDeleteTruck()}>Yes</Button>
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default DeleteTruckModal;
